import { configureStore, combineReducers } from "@reduxjs/toolkit"
import masterReducer from "./reducer/master/MasterReducer";
import assetReducer from "./reducer/assets/AssetReducer";
import maintenanceReducer from "./reducer/maintenance/MaintenanceReducer";
import loginReducer from "./reducer/login/LoginReducer";
import dashboardReducer from "./reducer/dashboard/DashboardReducer";
import globalReducer from "./reducer/GlobalReducer";
import chatReducer from "./reducer/chat/ChatReducer";
import superAdminReducer from "./reducer/superAdmin/SuperAdminReducer";
import settingsReducer from "./reducer/settings/SettingsReducer";
import userManagementReducer from "./reducer/user_management/UserManagementReducer";
import reportReducer from "./reducer/report/ReportReducer";
import customerFreelancerLinkReducer from "./reducer/customer_freelancer_link/CustomerFreelancerLinkReducer";

const rootReducer = combineReducers({
    ...masterReducer,
    ...assetReducer,
    ...maintenanceReducer,
    ...loginReducer,
    ...dashboardReducer,
    ...globalReducer,
    ...chatReducer,
    ...superAdminReducer,
    ...settingsReducer,
    ...userManagementReducer,
    ...reportReducer,
    ...customerFreelancerLinkReducer,
});

const ERP_Store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default ERP_Store;